export default __webpack_public_path__ + "static/media/bullet.26853623.svg";